/**
 * 小专区公用方法：跳转等
 */

import * as reportDict from "../../constants/report-dictonary"
import * as storeConfigApi from "@api/store-config"
import * as jumpApi from "../../business/jumpToapp"

export default function (root) {
  const { $router, $route, $store } = root

  // 进入专区
  const goToZone = ({ zoneConfig, busItem, pfStructure, index, iformatParam }) => {
    delete $route.query.shelfTab
    let query = {
      ...$route.query,
      pfStructure: pfStructure,
      isFromShop: 1
    }
    if (zoneConfig.busType == 2 && zoneConfig && zoneConfig.isIpZone) {
      query.isIpZone = 1
    }
    if (zoneConfig.busType == 1 || (zoneConfig.busList && zoneConfig.busList[0] && zoneConfig.busList[0].newServiceZone == 1)) {
      query.serviceZone = 1
    }
    $router.push({
      path: `/order/${busItem.groupId}/biz/${busItem.busId}`,
      query
    })
    let iformat = reportDict.CLICK.ZONE_CLICK_BUY
    if (iformatParam) {
      // 若传了iformat，使用传入的iformat
      iformat = iformatParam
    } else if (pfStructure.indexOf("banner") > -1) {
      iformat = reportDict.CLICK.ZONE_CLICK_BANNER
    } else if (pfStructure.indexOf("more") > -1) {
      iformat = reportDict.CLICK.ZONE_CLICK_MORE
    }
    $store.dispatch("reportUserAction", {
      iformat,
      resultInfo: {
        groupId: busItem.groupId,
        busId: busItem.busId,
        pfStructure,
        index
      }
    })
  }

  // 跳转到活动页
  const jumpToActivity = ({ ipZoneConfig, activity, pfStructure, index, cacheDate = "" }) => {
    $store.dispatch("cacheState")
    setCacheDataSessionStorage(cacheDate)
    $store.dispatch("reportAndJump", {
      target: activity.link,
      iformat: `${reportDict.CLICK.IPZONE_CLICK_ACTIVITY}_${index}_${ipZoneConfig.groupId}`,
      resultInfo: {
        groupId: ipZoneConfig.groupId,
        index,
        target: activity.link,
        pfStructure
      }
    })
  }

  // banner跳转到活动页
  const jumpBannerActivity = ({ zoneConfig, busItem, pfStructure, index, cacheDate = "" }) => {
    if (zoneConfig.busList && zoneConfig.busList[0] && zoneConfig.busList[0].jumpUrl) {
      $store.dispatch("cacheState")
      setCacheDataSessionStorage(cacheDate)
      $store.dispatch("reportAndJump", {
        target: zoneConfig.busList[0].jumpUrl,
        iformat: reportDict.CLICK.ZONE_CLICK_BANNER,
        resultInfo: {
          groupId: zoneConfig.groupId,
          busId: busItem.busId,
          target: zoneConfig.busList[0].jumpUrl,
          pfStructure,
          index
        }
      })
    } else {
      // 当没有配置jumpUrl时，则跳转业务购买页
      let query = {
        ...$route.query,
        pfStructure: pfStructure,
        isFromShop: 1
      }
      if (busItem.newServiceZone == 2) {
        query.isIpZone = 1
      }
      if (busItem.newServiceZone == 1) {
        query.serviceZone = 1
      }
      $router.push({
        path: `/order/${busItem.groupId}/biz/${busItem.busId}`,
        query
      })
      $store.dispatch("reportUserAction", {
        iformat: reportDict.CLICK.ZONE_CLICK_BANNER,
        resultInfo: {
          groupId: busItem.groupId,
          busId: busItem.busId,
          pfStructure,
          index
        }
      })
    }
  }

  // 跳转到外部货架
  const jumpToOuterShelf = ({ ipZoneConfig, outerShelf, pfStructure, cacheDate = "" }) => {
    if (
      ipZoneConfig?.mallType === "video" &&
      jumpApi.isSupportTerminal({ isWxConfigSuccess: $store.getters.isWxConfigSuccess, type: "more" })
    ) {
      $store.dispatch("reportUserAction", {
        iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT_MORE}_${ipZoneConfig.groupId}`,
        resultInfo: {
          groupId: ipZoneConfig.groupId,
          target: jumpApi.appJumpLink({ type: "more" }),
          pfStructure
        }
      })
      jumpApi.jumpToAppItem({ type: "more" })
      return
    }
    let jumpUrl = outerShelf.link
    if (jumpUrl) {
      $store.dispatch("cacheState")
      setCacheDataSessionStorage(cacheDate)
      $store.dispatch("reportAndJump", {
        target: jumpUrl,
        iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT_MORE}_${ipZoneConfig.groupId}`,
        resultInfo: {
          groupId: ipZoneConfig.groupId,
          target: jumpUrl,
          pfStructure
        }
      })
    }
  }

  // 指定商品跳转到外部商品页面
  const jumpToOuterShelfItem = ({ ipZoneConfig, jumpUrl, pfStructure, index, cacheDate = "" }) => {
    // 视频需要打开小程序
    const { cid, vid } = ipZoneConfig?.hotRecommend[index - 1] || ""
    if (
      ipZoneConfig?.mallType === "video" &&
      jumpApi.isSupportTerminal({ cid, vid, isWxConfigSuccess: $store.getters.isWxConfigSuccess })
    ) {
      $store.dispatch("reportUserAction", {
        iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT}_${index}_${ipZoneConfig.groupId}`,
        resultInfo: {
          groupId: ipZoneConfig.groupId,
          index,
          pfStructure,
          target: jumpApi.appJumpLink({ cid, vid })
        }
      })
      jumpApi.jumpToAppItem({ cid, vid })
      return
    }
    $store.dispatch("cacheState")
    setCacheDataSessionStorage(cacheDate)
    $store.dispatch("reportAndJump", {
      target: jumpUrl,
      iformat: `${reportDict.CLICK.IPZONE_CLICK_HOT}_${index}_${ipZoneConfig.groupId}`,
      resultInfo: {
        groupId: ipZoneConfig.groupId,
        index,
        pfStructure,
        target: jumpUrl
      }
    })
  }

  // 跳转专区道具详情页
  const goDetail = ({ bizConfig, item, pfStructure, index, cacheDate = "" }) => {
    if (!bizConfig.newServiceZone) {
      // 非专区（外跳）道具
      $store.dispatch("cacheState")
      setCacheDataSessionStorage(cacheDate)
    }
    $router.push({
      path: `/detail/${bizConfig.groupId}/biz/${bizConfig.busId}/goods/${item.itemExtend.AMSID}`,
      query: {
        ...$route.query,
        serviceZone: 1,
        pfStructure: `${pfStructure}_${index}`
      }
    })
    $store.dispatch("reportUserAction", {
      iformat: reportDict.CLICK.ZONE_CLICK_GOODS,
      resultInfo: {
        groupId: bizConfig.groupId,
        busId: bizConfig.busId,
        id: item.itemExtend.AMSID,
        index,
        pfStructure
      }
    })
  }

  const setCacheDataSessionStorage = cacheDate => {
    sessionStorage && sessionStorage.setItem("mallshop_zonelist", JSON.stringify(cacheDate))
  }

  const getMainColor = () => {
    let pfSourceConfig = storeConfigApi.getSourceConfig($store.getters.storeConfig, $store.getters.pfSource)
    return (pfSourceConfig && pfSourceConfig.mainColor) || ""
  }

  return {
    goDetail,
    goToZone,
    jumpToActivity,
    jumpBannerActivity,
    jumpToOuterShelf,
    jumpToOuterShelfItem,
    setCacheDataSessionStorage,
    getMainColor
  }
}
